import React from "react";
import { api, API } from "../lib/api";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { DownloadSimple, Printer } from "@phosphor-icons/react";
import { useAccounts } from "../lib/account";

async function downloadPeriodPdf(accountId, period) {
  try {
    const token = localStorage.getItem("tj_token");
    const url = `${API}/trades/export/pdf?account_id=${accountId}&period=${period}`;
    toast.info("Generating PDF…");
    const resp = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (resp.status === 402) return toast.error("PDF export is a paid feature", { description: "Subscribe to unlock" });
    if (!resp.ok) return toast.error("Export failed");
    const blob = await resp.blob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `tradelog-${period}.pdf`;
    a.click();
    URL.revokeObjectURL(a.href);
    toast.success(`${period[0].toUpperCase() + period.slice(1)} report downloaded`);
  } catch { toast.error("Export failed"); }
}

export default function ReportsCard() {
  const { activeId } = useAccounts();

  const periods = [
    { id: "daily", label: "Today", note: "Last 24h" },
    { id: "weekly", label: "This Week", note: "Last 7 days" },
    { id: "monthly", label: "This Month", note: "Last 30 days" },
    { id: "yearly", label: "This Year", note: "Last 365 days" },
    { id: "all", label: "All-time", note: "Everything" },
  ];

  return (
    <div className="rounded-xl border border-border bg-card p-4 sm:p-6 print:hidden">
      <div className="flex items-center justify-between mb-4 gap-2">
        <div className="min-w-0">
          <p className="text-[10px] tracking-[0.2em] uppercase text-muted-foreground">Reports</p>
          <h3 className="font-display text-base sm:text-lg font-semibold mt-1">Download or Print</h3>
        </div>
        <Button variant="outline" size="sm" onClick={() => window.print()} data-testid="print-report-btn" className="shrink-0">
          <Printer size={14} className="sm:mr-1" /> <span className="hidden sm:inline">Print / screenshot</span>
        </Button>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-2">
        {periods.map(p => (
          <button key={p.id} onClick={() => downloadPeriodPdf(activeId, p.id)}
            data-testid={`report-${p.id}`}
            className="text-left rounded-md border border-border bg-secondary/40 hover:bg-secondary hover:border-primary/50 p-3 transition-colors">
            <div className="flex items-center gap-2 text-sm font-medium">
              <DownloadSimple size={14} /> {p.label}
            </div>
            <p className="text-[10px] text-muted-foreground mt-1">{p.note}</p>
          </button>
        ))}
      </div>
      <p className="text-[10px] text-muted-foreground mt-4">
        PDF includes KPIs and up to 200 recent trades. Use Print for a browser-native snapshot you can save as an image.
      </p>
    </div>
  );
}
